/**
 * 按钮功能类型
 */
export type ButtonFunctionType = 'buyNow' | 'addCart' | 'learnMore'

/**
 * ActiveShelf 文案配置接口
 * 注意：secondaryButtonText 和 shopNowText 作为高频属性保持在 data 的直接属性中
 */
export interface CopyConfig {
  /** Plus会员价格标签文本 */
  plusMemberPriceLabel?: string
  /** 会员价格标签文本 */
  memberPriceLabel?: string

  /** 库存显示文案模板，支持 {count} 占位符 */
  stockDisplayText?: string

  /** 上一页滑动按钮的无障碍标签（ActiveShelf 专用） */
  previousSlideLabel?: string
  /** 下一页滑动按钮的无障碍标签（ActiveShelf 专用） */
  nextSlideLabel?: string

  discountLabel?: string
  outOfStockLabel?: string
  limitedStock?: string
  couponTag?: string
}
